// @flow
import {graphql} from 'react-relay'
import createMutationPromise, {type MutationInput} from './createMutationPromise'
import type {
  AddProposalChangeInput as Input,
  AddProposalChangeMutationResponse as Response,
} from './__generated__/AddProposalChangeMutation.graphql'

type Variables = $ReadOnly<{
  input: MutationInput<Input>
}>

const mutation = graphql`
  mutation AddProposalChangeMutation($input: AddProposalChangeInput!) {
    addProposalChange(input: $input) {
      changeEdge {
        node {
          id
          databaseId

          ...LinkedRole_change
          ...Role_change
          ...Policy_change
          ...MoveItems_change
          ...ElectRoleFiller_change
        }
      }

      proposal {
        ...RoleSelect_proposal
        ...PolicySelect_proposal
        ...ElectRoleFillerSelect_proposal
        ...SupportedRoleSelect_proposal
        ...ProposeNowButton_proposal
      }
    }
  }
`

export default (input: MutationInput<Input>, typename: string): Promise<Response> => {
  const variables: Variables = {input}

  const optimisticResponse = {
    addProposalChange: {
      changeEdge: {
        node: {
          command: input.command,
          __typename: typename,
        },
      },
    },
  }

  const configs = [{
    type: 'RANGE_ADD',
    parentID: input.proposalId,
    connectionInfo: [{
      key: 'ChangeList_changes',
      rangeBehavior: 'append',
    }],
    edgeName: 'changeEdge',
  }]

  return createMutationPromise({
    mutation,
    variables,
    optimisticResponse,
    configs,
  })
}
